import * as React from 'react';
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import {useIntl} from 'react-intl'
import Button from "@mui/material/Button/Button";
import TextField from "@mui/material/TextField/TextField";
import IconButton from "@mui/material/IconButton/IconButton";
import { styled } from '@mui/material/styles';
import { useFormik, FieldArray,
   FormikProvider } from 'formik';
import setupProfile from "../../../validation/setup-profile";
import {AuthUserContext} from "../../../providers/AuthProvider";
import firebase from '../../../firebase/firebase'
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import Avatar from "@mui/material/Avatar/Avatar";
import AddIcon from "@mui/material/SvgIcon/SvgIcon";
import {useNavigate} from "react-router-dom";
import moment from 'moment'

export default function Portfolio ({parentCallback, projectEditCallback, artistAddProjectCallBack}) {
  const storageRef = firebase.storage().ref();
  const { user, profile } = React.useContext(AuthUserContext);
  const [projects, setProjects] = React.useState([])
  const navigator= useNavigate()
  React.useEffect(() => {
    const userRef = firebase.firestore().collection('users').doc(profile.id);
    userRef.get()
      .then(async (doc) => {
        if (doc?.data() && doc?.data()?.portfolio) {
         const list = []
          for(let d of  doc?.data()?.portfolio)  {
            if (d?.mediaFiles) {
              const media ={};
              if (d?.mediaFiles.cover) {
                media.cover = await downloadURL(d?.mediaFiles.cover)
              }
              if (d?.mediaFiles.trailer) {
                media.trailer = await downloadURL(d?.mediaFiles.trailer)
              }
              if (d?.mediaFiles.image) {
                media.image = await downloadURL(d?.mediaFiles.image)
              }
              if (d?.mediaFiles.gallery){
                media.gallery = []
                for(let x of d?.mediaFiles.gallery){
                  const gallery = await downloadURL(x)
                  media.gallery.push({src:gallery, url:x})
                }
              }

                list.push ({
                  ...d, media
                })


            } else {
              list.push(d)
            }
            if (list.length === doc?.data()?.portfolio.length)           {
              setProjects(list)}
          }
        }
      })
  }, [])
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
      })
      .catch((error) => {
        reject(error)
        switch (error.code) {
          case 'storage/object-not-found':
            break;
          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;

          case 'storage/unknown':
            break;
        }
      });
  }))
  return(
    <>
      {/* Hero unit */}


      <Container maxWidth="md" component="main" sx={{my: 5, textAlign: 'left'}}>
        <Grid container  >
          <Grid xs={12}  >
            <Stack direction={'column'} component={'form'}  justifyContent="center"
                   alignItems="start"  spacing={5} sx={{}}>
              <span/>

              <Typography variant={'h5'} color={'primary'} sx={{borderBottom: '1px solid #204488', textTransform: 'uppercase',width: '100%'}} >
                Projects
              </Typography>
              {
                projects.length > 0 &&
                projects.map((project, index) => (
                  <Stack direction={'row'} key={index} justifyContent="center"
                         alignItems="flex-start" spacing={5}>
                    <Stack direction={'column'} justifyContent="center"
                           alignItems="flex-start" spacing={2} >
                      <Typography variant={'h6'} color={'primary'}>
                        {project?.title}
                      </Typography>
                      {project?.mediaFiles && project?.mediaFiles.cover && project?.media?.cover &&  <img src={project?.media?.image} style={{width: 150, height: 233, objectFit: 'cover'}}/>}

                      {
                        profile?.userType === 'artist' || profile?.userType === 'creator' ? <Button variant={'outlined'} sx={{textTransform:'inherit'}} color={'primary'} size={"small"} onClick={() => projectEditCallback(true, index,  project, 'details')}>
                        See more
                      </Button> : <></>}
                    </Stack>
                    <Stack direction={'column'} justifyContent="center"
                           alignItems="flex-start" spacing={3} >
                      <span />
                      <Stack direction={'column'} justifyContent="center"
                             alignItems="flex-start" spacing={3}>
                        <Typography variant={'body1'} color={'primary'}>
                          Description:
                        </Typography>
                        <Typography variant={'body2'} color={'secondary'}>
                          {project?.description}
                        </Typography>

                      </Stack>

                      {
                        profile?.userType === 'artist' ? '' :  <Stack direction={'row'} justifyContent="flex-start"
                             alignItems="center" spacing={3}>
                        <Typography variant={'body1'} color={'primary'}>
                          Genre:
                        </Typography>
                        <Stack
                          direction={'row'} spacing={1}>
                          {project?.genre && project?.genre.length>0 && 
                          Array.isArray(project?.genre) ? //Added this condition cause the older projects were breaking as they werent saved in array
                          project?.genre.map((genres, i)=>
                            <Typography
                            key={i}
                            variant={"body1"}
                            color={"text.secondary"}
                            sx={{ textTransform: "capitalize" }}>
                              {genres},
                            </Typography>
                              )
                              :
                             <Typography
                             variant={"body1"}
                             color={"text.secondary"}
                             sx={{ textTransform: "capitalize" }}>
                              {project?.genre}
                             </Typography> 
                            }
                          </Stack>

                      </Stack> }

                      <Stack direction={'row'} justifyContent="flex-start"
                             alignItems="center" spacing={3}>
                        <Typography variant={'body1'} color={'primary'}>
                          Role:
                        </Typography>
                        <Typography variant={'body1'} color={'secondary'}>
                          {project?.role}
                        </Typography>

                      </Stack>
                      {
                        profile?.userType === 'artist' ? '' :  <Stack direction={'row'} justifyContent="flex-start"
                                                                      alignItems="center" spacing={3}>
                          <Typography variant={'body1'} color={'primary'}>
                            Release date:
                          </Typography>
                          <Typography variant={'body1'} color={'secondary'}>
                            {moment(project?.endDate).format('MMMM D, YYYY')}
                          </Typography>

                        </Stack>
                      }

                    </Stack>

                  </Stack>
                ))
              }
              <span/>
              <span/>
              <Stack direction={'row'} justifyContent="center"
                     alignItems="center"  spacing={5} sx={{width: '100%'}}>
                <Button variant={'contained'} color={'warning'} sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,backgroundColor:'#FD4A01'}} onClick={()=> profile?.userType === 'artist' ? artistAddProjectCallBack(true):parentCallback(true)}>Add project</Button>

              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  )

};
